/**
 * Eén label van een project als gekleurde chip, zoals in de kolom LABELS van
 * het projectenoverzicht en de dashboardkaart 'Projecten met ster'. De kleur
 * is een naam uit LABEL_COLORS (CSS-klasse `label-chip--<naam>`).
 * AI-CONTEXT: See src/helpers/adressHelpers/resolveAdressLabels.js
 *
 * @param {object} props
 * @param {{label: string, color: string}} [props.label] - Het label uit de instellingen; ontbreekt het, dan de sleutel in grijs
 * @param {string} props.labelKey - De sleutel zoals hij op het project staat
 * @returns {JSX.Element}
 */
const ProjectLabelChip = ({ label, labelKey }) => (
    <span className={`label-chip label-chip--${label?.color || 'grey'}`}>{label?.label || labelKey}</span>
)

export default ProjectLabelChip
